import { TLanguage } from 'config/tenancy';

import maskEmail from './maskEmail';
import maskPhoneNumber from './maskPhoneNumber';

export interface ICodeValidationContact {
  email?: string;
  phone?: string;
  validWhatsapp?: boolean;
  maskedEmail?: string;
  maskedPhone?: string;
}

export default function getMaskedContact(
  customer: ICodeValidationContact,
  language: TLanguage,
) {
  return {
    email: customer.maskedEmail || maskEmail(customer.email),
    phone: customer.maskedPhone || maskPhoneNumber(customer.phone, language),
  };
}
